// ============================================================================
// === Configuration de la carte Mapbox ===
// Ce fichier contient les constantes de configuration de la carte.
// Modifier uniquement si nécessaire pour ajuster les paramètres de base.
// ============================================================================

export const MAP_CONFIG = {
  defaultCenter: [3.0586, 50.6333] as [number, number], // Lille coordinates
  defaultZoom: 12,
  minZoom: 9,
  maxZoom: 17,
  controlPosition: 'top-right' as 'top-right'
} as const;

